import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';
import GmapInfoWindow from 'vue2-google-maps/dist/components/infoWindow';

// tslint:disable
export const GmapMap = Vue.component('GmapMap', (VueGoogleMaps as any).Map);
export const GmapMarker = Vue.component('GmapMarker', (VueGoogleMaps as any).Marker);
export const Cluster = Vue.component('GmapCluster', GmapCluster as any);
export const InfoWindow = Vue.component('GmapInfoWindow', GmapInfoWindow as any);
// tslint:enable



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/components/map/MapComponents.ts